import { render } from "./SupplyList.vue?vue&type=template&id=50da12a7&scoped=true&ts=true&lang=pug"
import script from "./SupplyList.vue?vue&type=script&lang=ts&setup=true"
export * from "./SupplyList.vue?vue&type=script&lang=ts&setup=true"

import "./SupplyList.vue?vue&type=style&index=0&id=50da12a7&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50da12a7"]])

export default __exports__